import { getLimits } from './get-limits'
import { getOrderSum } from './get-order-sum'

export const limitsApi = {
  getLimits: getLimits,
  getOrderSum: getOrderSum,
}
